export const CONTACTS_VIEW_MODE = {
  list: 'LIST',
  formAdd: 'FORM_ADD'
}
